<template>
  <div>
    <div class="input-group my-2 bg-">
      <div
        v-if="!appendIcon"
        class="input-group-prepend"
      >
        <span class="input-group-text">
          <i :class="`fa ${icon}`"></i>
        </span>
      </div>
      <input
        :id="id"
        :class="{ 'form-control pr-2': true, 'bg-flat-clouds text-body': readonly }"
        v-show="!focused"
        :value="display"
        @focus.prevent="onFocus"
        readonly="readonly"
      />
      <input
        :class="{ 'form-control pr-2': true, 'bg-flat-clouds text-body': readonly }"
        :placeholder="placeholder"
        v-model="currentValue"
        v-show="focused"
        :type="type"
        :readonly="readonly"
        @blur="onBlur"
      >
      <div
        v-if="appendIcon"
        class="input-group-append"
      >
        <span class="input-group-text">
          <i :class="`fa ${icon}`"></i>
        </span>
      </div>
    </div>
    <span v-if="help" class="d-block mt-1 small">{{ help }}</span>
  </div>
</template>

<style lang="scss" scoped>
.input-group-prepend, .input-group-append, .form-control, .input-group-text {
  border: 0;
  border-bottom: 2px solid #111;
  border-radius: 0;
  background: none;
}
.input-group-text {
  border: 0;
  padding-left: 0 !important;
  margin-left: 0 !important;
  padding-right: 0 !important;
  margin-right: 5px !important;
}
.form-control {
  text-align: right;
  padding-right: 0;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #ddd;
}
::-moz-placeholder { /* Firefox 19+ */
  color: #ddd;
}
:-ms-input-placeholder { /* IE 10+ */
  color: #ddd;
}
:-moz-placeholder { /* Firefox 18- */
  color: #ddd;
}
</style>

<script>
import numeral from 'numeral'
import $ from 'jquery'
import { get, set } from 'lodash'

const mustBePercentage = (object, field) => {
  let value = get(object, field)

  if (parseInt(value) !== value) {
    set(object, field, parseInt(value))
  } else if (value > 100) {
    set(object, field, 100)
  } else if (value < 0) {
    set(object, field, 0)
  }
}

export default {
  props: {
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'number'
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: '1,1'
    },
    placeholder: {
      type: [String, Number],
      default: ''
    },
    icon: {
      type: String,
      default: 'fa-hashtag'
    },
    appendIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      focused: false,
      currentValue: this.value
    }
  },
  computed: {
    display () {
      return this.type === 'number' ? numeral(this.currentValue).format(this.format) : this.currentValue
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    },
    currentValue (value) {
      if (!this.readonly) {
        if (this.type === 'percent') {
          mustBePercentage(this, 'currentValue')
        }
        this.$emit('input', this.currentValue)
      }
    }
  },
  methods: {
    onFocus () {
      if (!this.readonly) {
        this.focused = true
        this.$nextTick(() => {
          $(this.$el).find('input:last').select()
        })
      }
    },
    onBlur () {
      this.focused = false
    }
  }
}
</script>